(function () {
  function initReviewSlider(section) {
    if (!section || section.dataset.mc4Ready === 'true') return;
    section.dataset.mc4Ready = 'true';

    var track = section.querySelector('[data-mc4-review-track]');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.mc4-review-card'));
    var prev = section.querySelector('[data-mc4-prev]');
    var next = section.querySelector('[data-mc4-next]');
    var dotsWrap = section.querySelector('[data-mc4-dots]');
    var index = 0;

    function visibleCount() {
      if (window.innerWidth <= 749) return 1;
      if (window.innerWidth <= 1080) return 2;
      return 4;
    }

    function maxIndex() {
      return Math.max(cards.length - visibleCount(), 0);
    }

    function goTo(i) {
      index = Math.max(0, Math.min(i, maxIndex()));
      var target = cards[index];
      if (target) {
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      updateDots();
    }

    function createDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i <= maxIndex(); i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mc4-dot';
        dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
        (function (n) { dot.addEventListener('click', function () { goTo(n); }); })(i);
        dotsWrap.appendChild(dot);
      }
      updateDots();
    }

    function updateDots() {
      if (!dotsWrap) return;
      Array.prototype.slice.call(dotsWrap.children).forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    if (prev) prev.addEventListener('click', function () { goTo(index <= 0 ? maxIndex() : index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index >= maxIndex() ? 0 : index + 1); });

    window.addEventListener('resize', function () { createDots(); goTo(index); });
    createDots();
  }

  function initVariantSync(root) {
    if (!root) return;
    var selects = Array.prototype.slice.call(root.querySelectorAll('.mc4-variant-select'));
    var priceEls = Array.prototype.slice.call(root.querySelectorAll('[data-mc4-price]'));
    var compareEls = Array.prototype.slice.call(root.querySelectorAll('[data-mc4-compare]'));
    if (!selects.length) return;

    function updateFrom(select) {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      selects.forEach(function (other) {
        if (other !== select) other.value = select.value;
      });
      if (opt.dataset.price) priceEls.forEach(function (el) { el.textContent = opt.dataset.price; });
      if (opt.dataset.compare) compareEls.forEach(function (el) { el.textContent = opt.dataset.compare; });
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () { updateFrom(select); });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mc4-review-section]').forEach(initReviewSlider);
    document.querySelectorAll('.mc4').forEach(initVariantSync);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    initReviewSlider(event.target.querySelector('[data-mc4-review-section]') || event.target);
    initVariantSync(event.target.querySelector('.mc4') || event.target);
  });
})();
